import { render, staticRenderFns } from "./FccEventProduct.vue?vue&type=template&id=48972710&scoped=true&"
import script from "./FccEventProduct.vue?vue&type=script&lang=js&"
export * from "./FccEventProduct.vue?vue&type=script&lang=js&"
import style0 from "./FccEventProduct.vue?vue&type=style&index=0&id=48972710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48972710",
  null
  
)

export default component.exports